<template>
    <div class="join">
        <div class="top-head">
            <img src="../../assets/imgs/map.png" style="width:100%;"/>
            <div class="box">
                <div style="color:#1b1b1b;font-size: 78px;font-weight: Bold;line-height: 86px;display: inline-block;width: 700px;">
                    A brand  <br/>with profound <br/> cultural <br/> background
                </div>
                <div style="width:486px;display: inline-block;">
                    <div style="width:200px;display: inline-block;">
                        <p><span>65</span>年历史</p>
                        <p><span>19</span>个国家及地区</p>
                    </div>
                    <div style="width:280px;display: inline-block;">
                        <p><span>200</span>余本教育著作</p>
                        <p><span>720</span>篇教案全球同步更新</p>
                    </div>
                </div>
                <p style="margin-top: 50px;">教学中心遍布中国、日本、美国、</p>
                <p> 加拿大、澳大利亚、英国、新加坡、马来西亚、泰国等19个国家及地区。</p>
                <p style="margin-top: 20px;">*此数据截止2022年9月</p>
            </div>
        </div>
        <div class="section-content">

            <img src="../../assets/imgs/brand/brand-qtz.png" />

            <div class="map">
                <div class="banner">
                    <div class="content">2009年进入中国, 40多个大中型城市, 110多家教学中心</div>
                </div>
                <!--<img src="../../assets/imgs/brand/brand-map.png" style="margin: 20px 0px; width: 100%;">-->
                <img style="margin: 20px 0px; width: 100%;" src="http://sk-moment.sikegroup.com/pc-city.jpg" alt="">
                <!--<span style="position:absolute;bottom:50px;left:40px;font-size: 16px;">*数据截止到2020年6月</span>-->
            </div>

            <div class="ceo">
                <div style="width: 580px;">
                    <img src="../../assets/imgs/brand/ceo.png" style="width: 100%;">
                </div>
                 <div class="infoBox">
                     <div class="title" style="margin-top: 110px;">
                         <div>Shichida  China</div>
                         <p class="black" style="font-family: Heavy;">七田真中国·创始人</p>
                     </div>
                     <div style="font-size: 60px;font-weight: 600;color:#303030;margin-top: 60px;">马思延</div>
                     <span style="display: inline-block;width:40px;height:0px;border-bottom: 5px solid #fdb813;margin-top: 20px;"></span>
                     <div style="font-family: Medium;font-size: 24px;color:#303030;margin: 20px 0px;">思可国际教育集团董事长</div>
                    <p>思可国际教育集团、七田真国际教育CEO</p>
                    <p>科学育儿探索者</p>
                    <p>长春大学、黑龙江外国语学院、黑龙江东方学院、</p>
                    <p>哈尔滨华德学院、广东第二师范学院  <b> 教授</b> </p>
                    <p>思可爱心基金  <b> 创始人</b></p>
                    <p style="margin-top: 40px">方正集团创始员工，前彭博资讯亚太区运营总裁。2009年归国，创立思可教育。10年深耕，通过引入著名品牌七田真、小王子等，将国际先进的教育理念、脑科学研究的最新成果应用于中国儿童早期教育及早期教育产业。</p>
                    <!-- <p style="margin-top:20px"> 自2008年起关注、研究中国早期教育，2009年将最适合东方文化的世界知名早期教育品牌——七田真正式引入中国。</p> -->
                </div>
            </div>
            <div style="text-align: center;color:#452a15;font-size: 60px;font-weight: 600;margin: 100px 0px 32px;">核心加盟优势</div>
            <img src="../../assets/imgs/foot-page/join-1.png" style="width: 990px;margin: 0px 100px;"/>
            <div class="strip">
                <p>如何成为我们的伙伴</p>
                <span></span>
            </div>
            <div style="font-size: 20px;font-weight: 300;color: #5e5e5e;text-align: center;line-height: 36px;">
                <p>七田真教育以“爱·严格·信赖”为品牌理念</p>
                <p> 以“让每一寸土地都成为孩子才能觉醒的地方”为品牌大理想 </p>
                <p>我们期待热爱教育、心怀梦想的有识之士共创伟业</p>
            </div>
            <div style="margin: 100px auto 24px;width: 950px;">
                <div class="required-bar" >投资人要求</div>
                <div class="flexBox" style="align-items: center;">
                    <div class="Box" style="width: 330px;">
                        <span>01</span>
                        <div style="width: 200px;">
                            <p style="font-weight: 600;">经验</p>
                            <p>需具备零售、服务行业工作</p>
                            <p>经验，教育、培训行业优先</p>
                        </div>
                    </div>
                    <div class="Box" style="width: 250px;">
                        <span>02</span>
                        <div style="width: 130px;">
                            <p style="font-weight: 600;">资金</p>
                            <p>前期投资计划</p>
                            <p>不低于300万</p>
                        </div>
                    </div>
                    <div class="Box" >
                        <span>03</span>
                        <div>
                            <p style="font-weight: 600;">理念</p>
                            <p>认同七田真理念和品牌文</p>
                            <p>化，亲力亲为，诚信经营</p>
                        </div>
                    </div>
                </div>

            </div>
            <div style="width:1000px;margin: 0px auto;">
                <div class="strip">
                    <p>加盟合伙流程</p>
                    <span></span>
                </div>
                <img src="../../assets/imgs/foot-page/join-2.png" style="width: 100%;"/>
                <div class="strip">
                    <p>中心环境</p>
                    <span></span>
                </div>
                <img src="../../assets/imgs/foot-page/join-3.jpg" style="width: 100%;"/>
            </div>
            <div class="btn-join">
                <div style="color:#313131;font-size: 55px;font-weight: 600;">加盟合伙</div>
                <p style="margin-top: 20px;">如果您对这份事业感兴趣，请加入我们！</p>
                <p>我们将尽快与您联系。</p>
                <p style="margin-top: 14px;">七田真·期待您的参与！</p>
                <div class="subBtn" @click="routeFn">七田真加盟申请表</div>
            </div>

        </div>
        <div class="no-look">
            <div class="city_box">
                <div>目前暂不开放区域</div>
                <div class="city_name">
                    <span v-for="item in cityArr" :key="item">{{item}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                cityArr:['深圳','北京','上海','昆明','广州','厦门','杭州','重庆','淄博','南京','西安','武汉','福州','合肥','石家庄','沈阳','成都','温州','无锡','郑州','苏州','济南','南宁','金华','河源','漳州','义乌','徐州','哈尔滨','天津','泉州','嘉兴','佛山','长沙','三亚','宁波','绍兴','诸暨','太原','焦作','洛阳','台州'],

            }
        },
        created(){

        },
        methods:{
            routeFn(){
                this.$router.push('/join-apply');
            }
        }
    }

</script>
<style lang="less" scoped>

    .join {
        color: #5e5e5e;
        font-size: 20px;
        .no-look{
            width: 100%;
            // height: 200px;
            background-image: -webkit-linear-gradient(left, #B4B4B4, #B4B4B4);
            padding: 30px 0px 50px;
            position: relative;
            bottom: -20px;
            z-index: -10;
            .city_box{
                color: #fff;
                font-size: 19px;
                font-weight: 700;
                letter-spacing: 2px;
                width: 960px;
                margin: 16px auto;
                .city_name{
                    font-size: 17px;
                    margin-top: 20px;
                    span{
                        line-height: 30px;
                        margin-right: 20px;
                    }
                }
            }
        }
        .top-head {
            position: relative;
            width: 92%;
            min-width: 1190px;
            margin: 0px auto;
            padding-bottom: 230px;
            min-height: 300px;
            .box {
                position: absolute;
                bottom: 0px;
                left: 50%;
                transform: translateX(-50%);
                width: 1190px;
                height: 530px;
                p{
                //    font-weight: 600;
                    font-size: 18px;
                    color: #5e5e5e;
                    span{
                        color: #f6ab00;
                        font-size: 60px;
                        font-weight: 600;
                    }
                }
            }
        }

        .ceo {
            display: flex;
            margin-top: 40px;
            align-items: center;
            .title{
                color: #fdb831;
                font-weight: 600;
                font-size: 30px;
            }
            .infoBox {
                width: 680px;
                height: 840px;
                background: url('../../assets/imgs/brand/ceo-bg.png') 100% 100% no-repeat;
                background-size: 100% 100%;
                padding-left: 60px;

                & > p {
                    line-height: 36px;
                    width: 534px;
                }
            }
        }

        .map{
            margin-top: 30px;
            position: relative;
            .banner{
                height: 150px;
                line-height: 150px;
                width: 100%;
                border-radius: 50px;
                background-color: #fdba21;
                .content{
                    display: inline-block;
                    width: calc(100% - 48px);
                    color: #ffffff;
                    font-size: 45px;
                    height: 100px;
                    line-height: 100px;
                    margin: 20px 20px;
                    border: 4px dashed #ffffff;
                    border-radius: 36px;
                    text-align: center;
                    font-weight: 600;
                    background-color: #fdb831;
                    box-shadow: 2px 8px 10px #e9ae3a;
                }
            }
        }

        .strip{
            text-align: center;
            font-size: 36px;
            color: #624d40;
            font-weight: 600;
            margin: 100px 0px 24px;
            span{
                width:50px;
                height: 8px;
                background-color: #f7b124;
                margin-top: 20px;
                display: inline-block;
            }
        }

        .required-bar{
            display: inline-block;
            background-color: #f7b124;
            font-size: 30px;
            font-weight: 600;
            text-align: center;
            color: #ffffff;
            height:60px;
            line-height: 60px;
            width: 330px;
            border-radius: 40px;
            margin-left: 310px;
            margin-bottom: 20px;
        }

        .Box{
            width: 300px;
            font-size: 16px;
            color: #303030;
            align-items: center;
            display: flex;
            span{
                font-size: 100px;
                color: #f7b124;
                font-weight: 600;
            }
            div{
                display: inline-block;
                width: 180px;
            }
        }
        .btn-join{
            margin: 30px auto;
            width: 900px;
            color:#5e5e5e;
            font-weight: 400;
            font-size: 20px;
            position: relative;
            .subBtn{
                color: #ffffff;
                height: 80px;
                line-height: 80px;
                text-align: center;
                background-color: #f7b124;
                font-size: 36px;
                font-weight: 600;
                border-radius: 36px;
                border: 2px solid #ffffff;
                box-shadow: 2px 6px 30px  #f7b124;
                width: 330px;
                position:absolute;
                top: 100px;
                right: 20px;
            }
        }
    }

</style>
